import { forwardRef } from 'react';

import * as S from './TextArea.style';

interface ITextAreaProps
	extends React.DetailedHTMLProps<
		React.TextareaHTMLAttributes<HTMLTextAreaElement>,
		HTMLTextAreaElement
	> {
	placeholder: string;
	defaultValue: string;
	maxLength: number;
}

const TextArea = forwardRef<HTMLTextAreaElement, ITextAreaProps>(
	({ placeholder, defaultValue, maxLength, ...props }: ITextAreaProps, ref) => (
		<S.MemoTextArea
			ref={ref}
			placeholder={placeholder}
			defaultValue={defaultValue}
			maxLength={maxLength}
			{...props}
		/>
	),
);

TextArea.displayName = 'TextArea';

export { TextArea };
